function assistantUrl (path) {
  const base = process.env.VUE_APP_BASE_URL || ''
  return `${base}${path}`
}

function parseSseChunk (buffer, onEvent) {
  const parts = buffer.split('\n\n')
  const rest = parts.pop()
  for (let i = 0; i < parts.length; i++) {
    const block = parts[i]
    const lines = block.split('\n')
    let data = ''
    for (let j = 0; j < lines.length; j++) {
      if (lines[j].indexOf('data:') === 0) {
        data += lines[j].slice(5).trim()
      }
    }
    if (!data) continue
    try {
      onEvent(JSON.parse(data))
    } catch (err) {
      onEvent({ event: 'error', message: 'Invalid assistant response' })
    }
  }
  return rest
}

function parseJsonBody (text) {
  try {
    return JSON.parse(text)
  } catch (err) {
    return { message: text }
  }
}

export async function streamAssistantChat ({ token, messages, onEvent, signal }) {
  const response = await fetch(assistantUrl('/api/assistant/chat'), {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
      Accept: 'text/event-stream'
    },
    body: JSON.stringify({ messages }),
    signal
  })

  if (!response.ok) {
    const text = await response.text()
    let message = text
    try {
      const parsed = JSON.parse(text)
      message = parsed.message || parsed || text
    } catch (err) {
      message = text || response.statusText
    }
    throw new Error(typeof message === 'string' ? message : 'Assistant request failed')
  }

  if (!response.body || !response.body.getReader) {
    throw new Error('Streaming is not supported in this browser')
  }

  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''

  while (true) {
    const { done, value } = await reader.read()
    if (done) break
    buffer += decoder.decode(value, { stream: true })
    buffer = parseSseChunk(buffer, onEvent)
  }
  if (buffer.trim()) {
    parseSseChunk(buffer + '\n\n', onEvent)
  }
}

export async function confirmAbsenceRequest ({ token, proposalId }) {
  const response = await fetch(assistantUrl('/api/assistant/confirm-absence'), {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ proposalId })
  })
  const text = await response.text()
  const parsed = parseJsonBody(text)
  if (!response.ok) {
    const err = new Error(
      (parsed && parsed.message) || (typeof parsed === 'string' ? parsed : 'Failed to submit absence request')
    )
    err.status = response.status
    throw err
  }
  return parsed
}
